'use strict';
import answers from './answer-store';

global.page_state = {};

// Mirror every AnswerStore write into `page_state.form_data`. Registered once,
// at module load. QSL scripts and the Handlebars `answer`/`ifanswer` helpers
// read `page_state.form_data`, so the store must write through to it — never
// replace it. Looks up `page_state` at call time because `clear_page_state`
// reassigns the global.
answers.subscribe(function (name, value) {
  page_state.form_data = page_state.form_data || {};
  page_state.form_data[name] = value;
});

global.clear_spd_elements_state = function () {
  /**
   * Clear and hide SPD (GDPR) consent content
   */
  $('.spd-consent-text p').text('');
  $('.spd-content').hide();
  if (mainNav) {
    mainNav.skipButton.hide();
  }
};

export function init_page_state(res) {
  if (res.init_state) {
    for (var name in res.init_state) {
      page_state[name] = res.init_state[name];
    }
  }
  // Seed the store from the API response on every load.
  answers.reset((res.init_state && res.init_state.form_data) || {});
}

export function clear_page_state() {
  $(window).off('resize.videoPlayer orientationChanged.videoPlayer');
  clear_spd_elements_state();
  $(page_state).unbind();
  page_state = {};
  page_state.vardata = {};
  page_state.page_events = {};
  // Clear the store alongside page_state so answers never leak across loads.
  answers.reset({});
}
